import DpButtonThemeConfig from '@/libs/components/DpUiComponents/DpButtonThemeConfig'
import styles from './index.scss'
import classnames from 'classnames'

type PropsType = {
  isTheme?: boolean
  style?: React.CSSProperties
  resetProps?: {
    style?: React.CSSProperties
    onClick?: Function | undefined
    text?: string
  }
  confirmProps?: {
    style?: React.CSSProperties
    onClick?: Function | undefined
    text?: string
  }
  className?: any
}

const DpButtonReset = (props: PropsType) => {
  return (
    <div className={classnames(styles['dp-button-reset'], props?.className)} style={props?.style}>
      <DpButtonThemeConfig
        type={'default'}
        isTheme={true}
        buttonText={props?.resetProps?.text || lang['重置']}
        {...props?.resetProps}
        style={{ flex: 1, ...props?.resetProps?.style, borderWidth: 0, borderRadius: '32px 0 0 32px' }}
      />
      <DpButtonThemeConfig
        isTheme={true}
        buttonText={props?.confirmProps?.text || lang['确认']}
        {...props?.confirmProps}
        style={{ flex: 1, ...props?.confirmProps?.style, borderWidth: 0, borderRadius: '0 32px 32px 0' }}
      />
    </div>
  )
}

export default DpButtonReset
